import React from 'react';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";

export class NavProductos extends React.Component {

	componentDidMount () {
		const script = document.createElement("script");

		script.async = true;

		script.innerHTML = ""; 

		document.body.appendChild(script);


	}




	render(){
		return <div>
					
					<nav class="nav-product-desktop">
						
						<div>
							<ul class="nav-productos-lb">
								<li class="seccion-productos">Productos</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="arandelas">Arandelas</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="bulones">Bulones</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll firstnavLink" exact={true} to="/">Tornillos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="tuercas">Tuercas</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll"  to="elementos-roscados-varios">Elementos roscados varios</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll"  to="accesorios-hidraulica-neumatica">Accesorios hidraulica/neumatica</NavLink>
								</li>
								<li class="nav-item">
									<NavLink  className="topScroll" to="elementos-sujecion-fijacion">Elementos de sujecion/fijacion</NavLink>
								</li>


								<li class="nav-item">
									<NavLink className="topScroll" to="grampas-ganchos">Grampas/Ganchos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="elementos-de-corte">Elementos de corte y abrasión</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="herramientas-accesorios">Herramientas/accesorios</NavLink>
								</li>

								<li class="nav-item">
									<NavLink className="topScroll" to="productos-quimicos">Productos quimicos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="bulones-automotor">Bulonería automotor</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="elementos-de-seguridad">Elementos de seguridad</NavLink>
								</li>

								<li class="nav-item">
									<NavLink className="topScroll" to="herramientas-automotor">Herramientas de automotor</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="soldadura">Soldadura</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="clavos-alambres">Clavos y alambres</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="pegamentos">Pegamentos</NavLink>
								</li>
							</ul>
							
						</div>
					</nav>
					
				</div>;
	}
} 


// WEBPACK FOOTER //
// ./src/components/NavProductos.js